<template>
    <div class="edc">
      <div class="container">
            <el-row :gutter="20">
                <el-col :span="24">
                    <h3>高效、严谨的EDC系统</h3>
                    <p>iTrial EDC 电子数据采集系统遵循国内外标准规范进行设计，支持与iTrial SDC无缝对接，无需二次转录，提高数据采集效率，降低数据管理成本。</p>
                </el-col>
            </el-row>
            <el-row :gutter="20">
                <el-col :span="4">
                    <div class="single-service-inner">
						<div class="thumb text-center">
							<img src="@/assets/img/pro/vms_ico_1.svg">
						</div>
						<h5>中心与访视管理</h5>
						<p class="text-center">面向租户级别，对所有项目的总览视图。 </p>
					</div>
                </el-col>
                <el-col :span="5">
                    <div class="single-service-inner">
						<div class="thumb text-center">
							<img src="@/assets/img/pro/vms_ico_2.svg">
						</div>
						<h5>库表管理</h5>
						<p class="text-center">可完全克隆真实世界病历表单的可视化建模，变量级的前端逻辑与核查规则设置，支持实验室与OCR兼容的动态指标范围管理。 </p>
					</div>
                </el-col>
                <el-col :span="5">
                    <div class="single-service-inner">
						<div class="thumb text-center">
							<img src="@/assets/img/pro/vms_ico_3.svg">
						</div>
						<h5>源数据映射</h5>
						<p class="text-center">访视过程数据100%支持映射到SDC系统，支持点对点映射，记录型表单映射及各种化验单据映射。 </p>
					</div>
                </el-col>
                <el-col :span="5">
                    <div class="single-service-inner">
						<div class="thumb text-center">
							<img src="@/assets/img/pro/mda_ico_3.svg">
						</div>
						<h5>智能数据核查</h5>
						<p class="text-center">支持自动核查与人工核查，支持DPL, Medical，Safety等多角色Review操作。支持研究病例导出及多种格式的数据导出。 </p>
					</div>
                </el-col>
                <el-col :span="5">
                    <div class="single-service-inner">
						<div class="thumb text-center">
							<img src="@/assets/img/pro/mda_ico_3.svg">
						</div>
						<h5>日志与记录管理</h5>
						<p class="text-center">完善的系统日志与操作记录留痕，随时随地的追溯和跟踪。满足NMPA稽查需要。 </p>
					</div>
                </el-col>
                <el-col :span="24">
                    <div class="section-title text-center" >
                        <h3 class="sub-title">丰富的功能模块，满足各种应用场景</h3>
                        <img src="@/assets/img/pro/sdc_pic_1.jpg">
                    </div>
                </el-col>
                
          </el-row>
          <section class="program-content">
                <el-row :gutter="20">
                    <el-col :span="24">
                        <div class="program-des">
							<h4>国内首家推出0编程前端逻辑、EditCheck设置</h4>
							<p>无额外学习成本，降低使用门槛，0编程模式创建各种复杂逻辑和规则，消除用户在使用软件方面的成本，把更多的精力聚焦在业务规则本身。</p>
							<p>支持跨访视跨表单进行规则设置，支持同时对多个核查目标设置规则</p>
                            <p>支持在配置规则时进行模拟测试，即时校验规则的正确性</p>
						</div>
                    </el-col>
                    <el-col :span="12">
                        <img src="@/assets/img/pro/edc_pic_1.jpg">
                    </el-col>
                    <el-col :span="12">
                        <img src="@/assets/img/pro/edc_pic_2.jpg">
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="24">
                        <div class="program-des">
							<h4>丰富的功能模块，满足各种应用场景</h4>
							<p>核心功能完善，满足临床I~IV期项目对数据管理的要求。</p>
						</div>
                    </el-col>
                    <el-col :span="24">
                        <img src="@/assets/img/pro/edc_pic_3.jpg">
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="24">
                        <div class="section-title text-center">
                        <h3 class="sub-title">为什么选择我们</h3>
                        <p class="title">一站式智能化临床研究服务供应商</p>
                    </div>
                    </el-col>
                    <el-col :span="6">
                        <div class="single-service-inner">
                            <div class="thumb text-center">
                                <img src="@/assets/img/pro/adv_1.jpg">
                            </div>
                            <h4>充分验证</h4>
                            <h6>广泛使用，认证资质齐全，安全可靠</h6>
                            <p>1000+临床研究采用；100+III期研究 </p>
                            <p>40+研究通过NMPA审核 </p>
                            <p>21 CFR Part 11（系统核心规范） </p>
                            <p>CDISC（数据交换标准） </p>
                            <p>完善权限管理 </p>
                        </div>
                    </el-col>
                    <el-col :span="6">
                        <div class="single-service-inner">
                            <div class="thumb text-center">
                                <img src="@/assets/img/pro/adv_2.jpg">
                            </div>
                            <h4>稳定易用</h4>
                            <h6>资深数据、统计、运营、稽查与医学人员 协同研发，稳定流畅</h6>
                            <p>EDC专家领导研发，一流底层架构 </p>
                            <p>电信级别机房，私有云方案，异地远程备份 </p>
                            <p>7*24快速服务响应；复杂页面加载时间小于2秒 </p>
                            <p>一个账号管理所有项目 </p>
                        </div>
                    </el-col>
                    <el-col :span="6">
                        <div class="single-service-inner">
                            <div class="thumb text-center">
                                <img src="@/assets/img/pro/adv_3.jpg">
                            </div>
                            <h4>功能强大</h4>
                            <h6>具有高度可配置与扩展性,大幅提升建库、录入、审核效率</h6>
                            <p>快速eCRF建立(支持CDASH标准) </p>
                            <p>强大高效率逻辑核查 </p>
                            <p>全面自定义功能、报表 </p>
                            <p>批量质疑、编码管理 </p>
                            <p>完善数据迁移方案 </p>
                            <p>动态访视控制（根据组别自动加载访视） </p>
                        </div>
                    </el-col>
                    <el-col :span="6">
                        <div class="single-service-inner">
                            <div class="thumb text-center">
                                <img src="@/assets/img/pro/adv_4.jpg">
                            </div>
                            <h4>中国价格</h4>
                            <h6>针对中国临床试验环境度身定制，性价比高</h6>
                            <p>针对中国临床试验环境度身定制，性价比高 </p>
                            <p>无反复培训、频繁维护等隐性成本 </p>
                        </div>
                    </el-col>
                </el-row>
          </section>
      </div>
    </div>
</template>
<script>

export default{
    data() {
        return {

        };
    },
    methods: {
      
    }
}
</script>
<style scoped>
.program-des {
    padding: 60px 30px 0;
    text-align: center;
}
.program-des h4{
  margin-bottom: 30px;
}
.single-service-inner {
  position: relative;
  border-radius: 8px;
  background: #fff;
  margin-bottom: 30px;
  /*box-shadow: 0px 5px 30px rgba(126, 86, 255, 0.1);*/
  transition: all 0.4s ease-in;
  /*clip-path: polygon(0 10%, 100% 0%, 100% 90%, 0% 100%);*/
  padding: 70px 10px 30px;
}
.page-service-area .single-service-inner {
  padding: 20px ;
}
.single-service-inner.style-2 {
  padding: 40px 40px 50px;
}
.single-service-inner.style-2 .thumb {
  margin-bottom: 23px;
}
.single-service-inner.style-2 .thumb img {
  width: auto;
}
.single-service-inner:hover {
  box-shadow: 0px 5px 30px rgba(126, 86, 255, 0.2);
}
.single-service-inner .thumb {
  margin-bottom: 35px;
}
.program-adv-area .single-service-inner .thumb img {
  
  max-height: 150px;
}
.single-service-inner h5 {
  margin-bottom: 14px;
  text-align: center;
}
.single-service-inner p {
  transition: all 0.4s ease-in;
}

.service--details-area p {
  font-size: 18px;
}
</style>